



















import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { PronosticoAireState } from '@/store/modules/pronostico-aire/types'
import { EtiquetaApi } from '@/domain/entities/Api'
import { getEnvironments } from '@/environments'
const env = getEnvironments()

@Component
export default class PronosticoAireControl extends Vue {
  @Getter('getPronosticoAire', { namespace: 'pronosticoAire' })
  pronosticoAireState!: PronosticoAireState
  @Action('setPosition', { namespace: 'googleMaps' })
  setPosition: any

  path: string = '/pronostico-aire'
  currentItem: number = 0
  unwatch: any;

  created () {
    if (this.isSubmenuSelected) {
      const position = env.settings.PRONOSTICO_AIRE.center
      const zoom = env.settings.PRONOSTICO_AIRE.zoom
      this.setPosition({ position, zoom })
    }
    this.currentItem = Number(this.$router.currentRoute.query.region || 0)
    this.unwatch = this.$store.watch(
      (state, getters) => state.pronosticoAire.isLoaded,
      (newValue, oldValue) => {
        if (newValue) {
          const selectedItem = this.selectedItem
          Number(this.$route.query.region) !== selectedItem.id &&
            this.$router.push({ query: { region: selectedItem.id } })
          this.handleClick(selectedItem)
          this.unwatch()
        }
      }
    )
  }

  beforeUpdate () {
    const selectedItem = this.selectedItem
    if (this.pronosticoAireState.isLoaded &&
      selectedItem != null &&
      this.$route.path === this.path &&
      Number(this.$route.query.region) !== selectedItem.id) {
      this.$router.push({ query: { region: this.selectedItem.id } })
    }
  }

  get selectedItem () {
    return this.computedEtiquetaList.filter((item) => item.id === this.currentItem)[0] || {}
  }

  get computedEtiquetaList (): any [] {
    if (this.pronosticoAireState && this.pronosticoAireState.etiqueta_list.length > 0) {
      return this.pronosticoAireState.etiqueta_list
    } else {
      return []
    }
  }
  get isSubmenuSelected () {
    return this.$route.path === '/pronostico-aire'
  }

  mergedEtiquetaRegion (item:EtiquetaApi): EtiquetaApi | undefined {
    const sections = env.settings.PRONOSTICO_AIRE.sections
    if (item && item.id != null) {
      this.currentItem = item.id
      const envItem = Object.entries(sections)
        .filter((result) => {
          if (result[1].id === item.id) {
            return result
          }
        })[0][1]
      if (item.centro && item.centro.latitud && item.centro.longitud) {
        return item
      } else {
        return {
          ...item,
          centro: {
            latitud: envItem.center.lat,
            longitud: envItem.center.lng
          },
          zoom: envItem.zoom
        }
      }
    } else {
      return undefined
    }
  }
  handleClick (item: EtiquetaApi) {
    if (item && item.centro && item.centro.latitud && item.centro.longitud) {
      const mergedItem = this.mergedEtiquetaRegion(item)
      if (mergedItem && mergedItem.centro) {
        // Handle click intercepts the native click from vue-router, that's why the url didn't update the first time.
        if (Number(this.$route.query.region) !== item.id) this.$router.replace(`/pronostico-aire?region=${item.id}`)
        this.setPosition({ position: { lat: mergedItem.centro.latitud, lng: mergedItem.centro.longitud }, zoom: mergedItem.zoom })
      }
    }
  }
}
